import { styled } from "../../../../styles";

export const CardDataContainer = styled("div", {
  width: "100%",
  height: "67%",
  padding: "18px 8px 0px 8px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "$2",
});

export const RecordingRow = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "$8",
  whiteSpace: "nowrap",

  p: {
    fontFamily: "$openSans",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "22px",
    color: "$black",
    margin: 0,
  },
});

export const Divider = styled("div", {
  width: "100%",
  height: "1px",
  backgroundColor: "rgba(0, 0, 0, 0.12)",
  borderRadius: "0.5px",
  margin: "10px 0",
});
